import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialGrid from "../../../../__snowpack__/pkg/@mui/material/Grid.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React, {useCallback} from "react";
import MergeHistoryCard from "../../molecules/merge-history-card/merge-history-card.component.js";
import {MergeUnitsHistoryContainer, MergeUnitsHistoryHeader} from "./merge-units-history.styles.js";
function MergeUnitsHistory({
  mergeHistory,
  onUnmerge
}) {
  const {
    t
  } = useTranslation();
  const renderMergeUnitCard = useCallback((history, index) => {
    return /* @__PURE__ */ React.createElement(MergeHistoryCard, {
      key: index,
      mergeHistory: history,
      onUnmerge
    });
  }, [onUnmerge]);
  if (!mergeHistory.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(MergeUnitsHistoryContainer, null, /* @__PURE__ */ React.createElement(MergeUnitsHistoryHeader, null, /* @__PURE__ */ React.createElement(MaterialTypography, {
    variant: "h5"
  }, t("units.mergeHistory"))), /* @__PURE__ */ React.createElement(MaterialGrid, {
    container: true,
    spacing: 2
  }, mergeHistory.map((history, index) => renderMergeUnitCard(history, index))));
}
export default /* @__PURE__ */ React.memo(MergeUnitsHistory);
